module.exports = __webpack_public_path__ + "img/6533.a944b9ff.jpg";